import { t } from '../i18n';
import cookies from 'react-cookies';
import { logout } from '../redux/actions/authActions';

/**
 * 서버로부터 응답받은 에러코드 한글 메시징 처리
 * - 에러 코드와 일차하는 메시지 반환
 * */
export const getErrorMessage = (data) => {
  // 우선 data?.code 확인하고 값이 비어있으면 data?.resultCode 사용
  let errorCode;
  if (data?.code === "NotFound") { // code 에 NotFound 박혀오는 경우 있어서 우선 처리
    errorCode = data?.resultCode;
  } else {
    errorCode = data?.code || data?.resultCode;
  }

  // en.json 에서 해당하는 에러 코드를 찾아 반환
  const errorMessage = t(`server.error.code.${errorCode}`);

  // 로그인 토큰정보 없음 / 토큰 만료 포함 의 경우 로그아웃 처리
  if (data?.resultCode === 401) {
    setTimeout(() => {
      cookies?.remove('token', { path: '/' });
      logout();
      window.location.assign('/');
    }, [3000]);
  }

  // 만약 에러 코드에 해당하는 메시지가 없다면 에러 코드와 기본 에러 메시지를 반환
  return (
    errorMessage ||
    `에러코드 ${errorCode} 로 알 수 없는 오류가 발생했습니다. 서버쪽 데이터를 확인 해주세요.`
  );
};
